import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/image/sm.png';
import _imports_1 from '../../assets/image/1.png';
import _imports_2 from '../../assets/image/2.png';
import _imports_3 from '../../assets/image/3.png';
import _imports_4 from '../../assets/image/4.png';
import _imports_5 from '../../assets/image/5.png';
import _imports_6 from '../../assets/image/6.png';
import _imports_7 from '../../assets/image/7.png';
import _imports_8 from '../../assets/image/banner.png';
import _imports_9 from '../../assets/image/11.png';
import _imports_10 from '../../assets/image/22.png';
import _imports_11 from '../../assets/image/33.png';
import _imports_12 from '../../assets/image/44.png';
import _imports_13 from '../../assets/image/55.png';
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "index_content"
};
const _hoisted_3 = {
  class: "box1"
};
const _hoisted_4 = {
  class: "box12"
};
const _hoisted_5 = {
  class: "box1"
};
const _hoisted_6 = {
  class: "box12"
};
import { ref, onMounted, onUnmounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const domain_url = ref('https://xueli2.cc');
    const router = useRouter();
    const goWeb = (u, s) => {
      if (s) {
        if (window.localStorage.getItem('token')) {
          router.push({
            path: '/web',
            query: {
              url: u + '?token=' + window.localStorage.getItem('token')
            }
          });
        } else {
          router.push({
            path: '/login'
          });
        }
      } else {
        router.push({
          path: '/web',
          query: {
            url: u
          }
        });
      }
    };
    onMounted(() => {});
    onUnmounted(() => {});
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: "学习"
      }, {
        right: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("img", {
          src: _imports_0,
          style: {
            "width": "20px"
          }
        }, null, -1)]))]),
        _: 1
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[17] || (_cache[17] = _createElementVNode("p", null, "学籍学历学位", -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "box13",
        onClick: _cache[0] || (_cache[0] = $event => goWeb(domain_url.value + '/archiveIndex', true))
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学籍查询", -1)]))]), _createElementVNode("div", {
        class: "box13",
        onClick: _cache[1] || (_cache[1] = $event => goWeb(domain_url.value + '/Query?name=xj'))
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("img", {
        src: _imports_2,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学籍验证", -1)]))]), _createElementVNode("div", {
        class: "box13",
        onClick: _cache[2] || (_cache[2] = $event => goWeb(domain_url.value + '/Scattered'))
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("img", {
        src: _imports_3,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学历查询 ", -1)]))]), _createElementVNode("div", {
        class: "box13",
        onClick: _cache[3] || (_cache[3] = $event => goWeb(domain_url.value + '/Query?name=xj'))
      }, [...(_cache[12] || (_cache[12] = [_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学历验证", -1)]))]), _createElementVNode("div", {
        class: "box13",
        onClick: _cache[4] || (_cache[4] = $event => goWeb(domain_url.value + '/Scattered'))
      }, [...(_cache[13] || (_cache[13] = [_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学历认证", -1)]))]), _createElementVNode("div", {
        class: "box13",
        onClick: _cache[5] || (_cache[5] = $event => goWeb(domain_url.value + '/Scattered'))
      }, [...(_cache[14] || (_cache[14] = [_createElementVNode("img", {
        src: _imports_6,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学位查询", -1)]))]), _createElementVNode("div", {
        class: "box13",
        onClick: _cache[6] || (_cache[6] = $event => goWeb(domain_url.value + '/Query?name=xj'))
      }, [...(_cache[15] || (_cache[15] = [_createElementVNode("img", {
        src: _imports_7,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "学位验证", -1)]))]), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "box13"
      }, null, -1))])]), _cache[23] || (_cache[23] = _createElementVNode("div", {
        class: "box2"
      }, [_createElementVNode("img", {
        src: _imports_8,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_5, [_cache[22] || (_cache[22] = _createElementVNode("p", null, "出国教育背景信息服务", -1)), _createElementVNode("div", _hoisted_6, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "box23 box23-1"
      }, [_createElementVNode("img", {
        src: _imports_9,
        alt: ""
      }), _createElementVNode("p", null, "中等教育学历")], -1)), _cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "box23 box23-2"
      }, [_createElementVNode("img", {
        src: _imports_10,
        alt: ""
      }), _createElementVNode("p", null, "高等教育学历")], -1)), _createElementVNode("div", {
        class: "box23 box23-3",
        onClick: _cache[7] || (_cache[7] = $event => goWeb(domain_url.value + '/College'))
      }, [...(_cache[18] || (_cache[18] = [_createElementVNode("img", {
        src: _imports_11,
        alt: ""
      }, null, -1), _createElementVNode("p", null, "高考成绩单", -1)]))]), _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"box23 box23-4\"><img src=\"" + _imports_12 + "\" alt=\"\"><p>中学成绩单</p></div><div class=\"box23 box23-5\"><img src=\"" + _imports_13 + "\" alt=\"\"><p>会考成绩单</p></div><div class=\"box23\"></div>", 3))])])])]);
    };
  }
};